export interface ConfigsProperties {
    BASE_API: string
    SHA1_SALT: string
    QINIU_HOST: string
}

const env = process.env.REACT_APP_ENV || 'dev'
const config = require(`./${env}`)

export default config.default
